import { useQuery } from "react-query";
import { sectionApiRequest } from "./client";
function fetchSection(sectionId) {
  return sectionApiRequest({ url: `/section/${sectionId}` });
}
function useSectionQuery(sectionId) {
  return useQuery(["section", sectionId], () => fetchSection(sectionId), {
    enabled: !!sectionId
  });
}
export {
  useSectionQuery
};
